module.exports = __webpack_public_path__ + "img/165.general_cleaning.5813071c.svg";